import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { DiviWordmark } from '@/components/generals/divi-logo'

const NAV_LINKS = [
    { href: '#variations', label: "Variations" },
    { href: '#colors', label: "Colors" }
]

export const SiteHeader: FC = (): ReactNode => {
    return (
        <header className='sticky top-0 z-40 border-b border-white/5 bg-background/70 backdrop-blur-xl'>
            <div className='mx-auto flex h-16 max-w-6xl items-center justify-between px-6'>
                <Link
                    href='/'
                    aria-label="Divi, back to the top"
                    className='rounded-md text-brand-red transition-opacity hover:opacity-85 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-red'
                >
                    <DiviWordmark tone='solid' aria-hidden='true' className='h-6 w-auto' />
                </Link>

                <nav aria-label="Primary">
                    <ul className='flex items-center gap-1'>
                        {NAV_LINKS.map(link => (
                            <li key={link.href}>
                                <a
                                    href={link.href}
                                    className='rounded-full px-3.5 py-2 text-sm font-medium text-muted-foreground transition-colors hover:bg-white/5 hover:text-foreground focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-red'
                                >
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>
        </header>
    )
}
